import Logo from '../../../Assets/img/Logo/logo.svg';
import WorkflowImg from '../../../Assets/img/General/Workflows.svg';
import Clientes from '../../../Assets/img/General/Clientes.svg';
import Reportes from '../../../Assets/img/General/Reportes.svg';

export const listMenu = [
  {
    name: 'Principal',
    img: Logo,
    alt: 'Integrador Img',
    link: '/',
    requiredAdmin: false
  },
  {
    name: 'Workflows',
    img: WorkflowImg,
    alt: 'Workflows Img',
    link: '/workflows',
    requiredAdmin: false
  },
  {
    name: 'Plantillas',
    img: WorkflowImg,
    alt: 'Plantillas Img',
    link: '/templates',
    requiredAdmin: true
  },
  {
    name: 'Clientes',
    img: Clientes,
    alt: 'Clientes Img',
    link: '/clients',
    requiredAdmin: true
  },
  {
    name: 'Reportes',
    img: Reportes,
    alt: 'Reportes Img',
    link: '/reports',
    requiredAdmin: false
  },
];
